import { Route } from '@angular/router';
import { requireAnyPermission } from '../../../auth/permission-guard';
import { PAGE_PERMISSIONS } from '../../../auth/permissions';

export const routes: Route[] = [
  {
    path: 'settings',
    children: [
      {
        path: '',
        loadComponent: () => import('./settings').then(({ SettingsPage }) => SettingsPage),
      },
      {
        path: 'dropdown',
        canActivate: [requireAnyPermission(PAGE_PERMISSIONS.DROP_DOWNS_VIEW)],
        loadComponent: () => import('./dropdown/dropdown').then(({ DropdownPage }) => DropdownPage),
      },
      {
        path: 'single-components-dropdown',
        canActivate: [requireAnyPermission(PAGE_PERMISSIONS.DROP_DOWNS_VIEW)],
        loadComponent: () =>
          import('./single-components-dropdown/single-components-dropdown').then(
            ({ SingleComponentsDropdownPage }) => SingleComponentsDropdownPage,
          ),
      },
      {
        path: 'fields',
        canActivate: [requireAnyPermission(PAGE_PERMISSIONS.SETTINGS_CORE)],
        loadComponent: () => import('./fields/fields').then(({ FieldsPage }) => FieldsPage),
      },
      {
        path: 'fields/:id',
        canActivate: [requireAnyPermission(PAGE_PERMISSIONS.SETTINGS_CORE)],
        loadComponent: () =>
          import('./field-dropdowns/field-dropdowns').then(
            ({ FieldDropdownsPage }) => FieldDropdownsPage,
          ),
      },
      {
        path: 'preferences',
        loadComponent: () =>
          import('./preferences/preferences').then(({ PreferencesPage }) => PreferencesPage),
      },
      {
        path: 'users-and-permissions',
        canActivate: [requireAnyPermission(PAGE_PERMISSIONS.SETTINGS_CORE)],
        loadComponent: () =>
          import('./users-and-permissions/users-and-permissions').then(
            ({ UsersAndPermissionsPage }) => UsersAndPermissionsPage,
          ),
      },
    ],
  },
];
